import { render, staticRenderFns } from "./MothersDay_cocktailsSection.vue?vue&type=template&id=a50ca07a&scoped=true"
import script from "./MothersDay_cocktailsSection.vue?vue&type=script&lang=ts"
export * from "./MothersDay_cocktailsSection.vue?vue&type=script&lang=ts"
import style0 from "./MothersDay_cocktailsSection.vue?vue&type=style&index=0&id=a50ca07a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50ca07a",
  null
  
)

export default component.exports